export default __webpack_public_path__ + "static/media/11b.38cb7913.png";